import React from 'react'
import { getData, patchData } from '../../Service/ApiMethod'
import { Recomended_Messages } from '../../Service/service'
import { useState } from 'react'
import { useEffect } from 'react'
import BackBar from '../home/BackBar'
import { useRef } from 'react'
import { useTranslation } from 'react-i18next'

const StoredMsg = () => {


  const [recomendedMsg, setRecomendedMsg] = useState([])
  const [update, setUpdate] = useState(false)
  const [idd , setIdd] = useState('')
  const [message , setMessage] = useState('')
  const [value , setValue] = useState('')

  const RecomendedMessage = () => {
    getData(Recomended_Messages)
      .then((resp) => resp.json())
      .then((data) => {
        setRecomendedMsg(data?.data);
        console.log('recomended msg', data.data);
      })
      .catch((err) => {
        console.log("Error ", err);

      });
  }


  console.log("rec-msg", recomendedMsg)


  const ref = useRef(null);
  useOutsideAlerter(ref);

  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
  setUpdate(false)
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }


  const handleUpdate =()=>{
 const obj ={
  id:idd,
  message:value
 }

  patchData(obj ,Recomended_Messages )
  .then((resp) => resp.json())
  .then((data) => {
   console.log('patch msg', data?.data);

    setUpdate(false)

    setTimeout(()=>{
      alert(data?.message)
    },[1000])
  })
  .catch((err) => {
    console.log("Error ", err);

  });

  }

  useEffect(() => {
    RecomendedMessage()
  }, [])

  
  useEffect(() => {
    RecomendedMessage()
  }, [update])

  

  // console.log('changed value', value)

  const {t} = useTranslation();
  
  return (
    <>
      <BackBar title={t('Stored Messages')} />
      {recomendedMsg != null ?
        (recomendedMsg?.slice().reverse()?.map?.((item, index) => {

          const rec = item?.message
          return (
            <div className='d-flex rec-msg -outer'>
 <div key={index} className='col-10 rec-msg ' style={{
              border: '1px solid black', borderRadius: '6px', height: '10vh', marginBottom: '10px', color:'black'
            }}

              onClick={(e) => {
                e.stopPropagation()
                setUpdate(true)
                setIdd(item?.id)
                setMessage(item?.message)

              }}
            >
         
         {rec}

              
            </div>
            </div>
           


          )
        }
        )


        ) : <> {t('No Data Found')}</>
      }

      {
        update && 

      <div className="blur-screen-full-area flex-center" >
     <div className="edit-profile"  ref={ref}>

{/* <div className='' style={{border:'1px solid black',borderRadius:'6px', width:"auto", height:'45vh' , color:'black', padding:'5px'}} >{message}</div> */}
<textarea   className=" w-100 mb-2 "
                rows="14"  type='textarea' defaultValue={message} style={{border:"1px solid black", borderRadius:'6px', color:'black'}}
                onChange={(e)=>{
                setValue(e.target.value)

                }} />

    <div className='d-flex justify-content-center my-3 align-items-end'>
    <button  className="link theme-btn text-link btn-block w-50" style={{display:'flex', justifyContent:'center', padding:'12px', color:'white', background:" #1c0950"}} onClick={()=>{
      handleUpdate()
    }}>Update</button>
      </div> 

        </div>
        </div>

                  
      }


    </>
  )
}

export default StoredMsg